import * as React from "react";

const AddIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14">
            <path
             fill="#fff" 
             fill-rule="evenodd" 
             d="M7.5 6.25v-6H6v6H0v1.5h6v6h1.5v-6h6v-1.5z"
             />
        </svg>
    );
};

export default React.memo(AddIcon);